import useTranslation from "next-translate/useTranslation";
import React, { useState } from "react";
import formatUrl from "utils/FormatUrl";
import Facebook from "../../agenzLogos/SocialGray/Facebook";
import LinkedIn from "../../agenzLogos/SocialGray/Instagram";
import Instagram from "../../agenzLogos/SocialGray/LinkedIn";
import style from "./Footer.module.css";
import dynamic from "next/dynamic";
import Image from "next/image";
import Logo from "agenzLogos/Logo";

function Footer(props) {
  const { t, lang } = useTranslation("footer");
  const [curretY, setCurrentY] = useState(new Date().getFullYear());

  const menus = [
    {
      title: t("Accueil"),
      path: `/${lang}`,
    },
    {
      title: t("Prix Immobiliers"),
      path: `/${lang}/prix-immobilier-maroc`,
    },
    {
      title: t("Annonces"),
      path: `/${lang}/list.htm`,
    },
    {
      title: t("Crédit immobilier"),
      path: `/${lang}/credit-immobilier-maroc`,
    },
    {
      title: t("Estimer un bien"),
      path: `/${lang}/estimation/map`,
    },
    {
      title: t("Trouver une agence"),
      path: `/${lang}/agence-immobiliere-maroc`,
    },
    {
      title: t("Le Mag"),
      path: "https://mag.agenz.ma/",
    },
    {
      title: t("Contact"),
      path: `/${lang}/contact`,
    },
    {
      title: t("CGU"),
      path: `/${lang}/conditions-d-utilisation`,
    },
    {
      title: t("CGV"),
      path: `/${lang}/conditions-d-utilisation#cgv`,
    },
  ];

  return (
    <div
      className={`${style.footer} ${props.isContact ? style.contactContainer : ""
        } `}
    >
      <div className={style.links}>
        <div className={style.logo_mobile}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="139"
            height="40"
            viewBox="0 0 139 40"
            fill="none"
          >
            <path
              d="M60.6955 26.4068V26.2336C60.3061 27.0635 59.7061 27.7216 58.8927 28.2064C58.0806 28.6912 57.1481 28.933 56.0949 28.933C53.6007 28.933 51.5637 28.0737 49.9854 26.3537C48.407 24.6352 47.6172 22.4486 47.6172 19.7953C47.6172 17.1881 48.3835 15.0253 49.9175 13.3053C51.45 11.5867 53.4524 10.7261 55.9245 10.7261C57.2742 10.7261 58.3384 10.9971 59.1172 11.5392C59.8945 12.0814 60.41 12.6416 60.6622 13.2173V11.2472H65.7076V25.3687C65.7076 26.4068 65.7533 27.4338 65.8447 28.4495H60.8326C60.7398 27.9409 60.6955 27.2605 60.6955 26.4068ZM52.869 19.8302C52.869 21.2148 53.2404 22.3228 53.9845 23.1527C54.7272 23.9827 55.6612 24.399 56.7822 24.399C57.8811 24.399 58.8012 23.9897 59.5453 23.1709C60.2881 22.3522 60.6608 21.2386 60.6608 19.8316C60.6608 18.4009 60.295 17.2873 59.562 16.4909C58.8289 15.6945 57.9019 15.2963 56.7822 15.2963C55.6155 15.2963 54.6704 15.6889 53.9499 16.4727C53.2293 17.258 52.869 18.3771 52.869 19.8302ZM67.6739 29.4178L72.273 28.103C72.4559 28.9567 72.873 29.6483 73.5257 30.1793C74.1784 30.7102 74.9848 30.9757 75.9451 30.9757C78.7595 30.9757 80.1674 29.51 80.1674 26.5801V25.7837C79.3207 27.0761 77.7992 27.7216 75.6015 27.7216C73.3359 27.7216 71.4485 26.9252 69.9381 25.3338C68.4277 23.7424 67.6725 21.7458 67.6725 19.3468C67.6725 17.04 68.4222 15.0616 69.9201 13.4115C71.418 11.7614 73.3123 10.9371 75.6015 10.9371C76.8597 10.9371 77.8893 11.1564 78.6902 11.5951C79.4912 12.0339 80.0399 12.5299 80.3378 13.0831V11.2472H85.3153V26.3034C85.3153 28.9805 84.549 31.1894 83.015 32.9317C81.481 34.674 79.2043 35.5445 76.1849 35.5445C73.8513 35.5445 71.9114 34.9381 70.3663 33.7267C68.8226 32.5154 67.9247 31.079 67.6739 29.4178ZM73.9206 22.1146C74.6066 22.8076 75.4879 23.1527 76.5632 23.1527C77.6385 23.1527 78.5142 22.8062 79.1891 22.1146C79.8639 21.423 80.202 20.4995 80.202 19.3454C80.202 18.2151 79.8473 17.2971 79.1378 16.5929C78.4283 15.8901 77.5692 15.5366 76.5632 15.5366C75.5558 15.5366 74.6925 15.8887 73.9719 16.5929C73.2513 17.2971 72.8911 18.2137 72.8911 19.3454C72.8911 20.4995 73.2347 21.423 73.9206 22.1146ZM99.5686 22.253L103.928 23.4993C103.493 25.0907 102.589 26.4012 101.216 27.4282C99.843 28.4551 98.1275 28.9679 96.067 28.9679C93.5949 28.9679 91.4955 28.1379 89.7675 26.4753C88.0396 24.814 87.1763 22.5869 87.1763 19.7953C87.1763 17.1183 88.0174 14.9386 89.6996 13.2536C91.3819 11.57 93.3773 10.7275 95.69 10.7275C98.3437 10.7275 100.432 11.5057 101.955 13.0636C103.476 14.6215 104.237 16.7843 104.237 19.5536C104.237 20.431 104.202 20.9731 104.135 21.1799H92.2577C92.3034 22.1258 92.7038 22.9166 93.4591 23.5509C94.2143 24.1853 95.1067 24.5024 96.1362 24.5024C97.8975 24.5024 99.0421 23.7535 99.5686 22.253ZM92.3602 17.7889H99.1903C99.1446 17.0051 98.8411 16.3246 98.2813 15.7476C97.7201 15.1706 96.879 14.8827 95.7579 14.8827C94.7505 14.8827 93.9496 15.1831 93.3551 15.7825C92.7607 16.3805 92.4281 17.0498 92.3602 17.7889ZM111.465 18.5839V28.4481H106.248V11.2472H111.293V13.2201C111.728 12.4586 112.397 11.8648 113.301 11.4372C114.204 11.0111 115.126 10.7973 116.064 10.7973C118.101 10.7973 119.645 11.4372 120.698 12.7185C121.75 13.9983 122.276 15.6428 122.276 17.6506V28.4495H117.059V18.5504C117.059 17.6506 116.825 16.9296 116.355 16.3875C115.885 15.8454 115.194 15.5743 114.278 15.5743C113.431 15.5743 112.751 15.8566 112.235 16.4224C111.723 16.9869 111.465 17.7079 111.465 18.5839ZM138.661 28.4481H124.346V23.8108L131.864 15.7462H124.553V11.2472H138.524V15.573L130.662 23.9142H138.661V28.4481Z"
              fill="#00B4FF"
            />
            <path
              d="M20.0062 0C9.14502 0 0.338867 8.87779 0.338867 19.8304C0.338867 30.783 9.14502 39.6608 20.0062 39.6608C30.8673 39.6608 39.6735 30.783 39.6735 19.8304C39.6735 8.87779 30.8687 0 20.0062 0ZM7.20642 26.8863L4.32554 23.9815C4.25625 23.9116 4.25625 23.7985 4.32554 23.7286L10.4282 17.5753C10.4781 17.525 10.5058 17.4566 10.5058 17.3853V11.573C10.5058 11.4738 10.5848 11.3941 10.6832 11.3941H14.7585C14.8569 11.3941 14.9359 11.4738 14.9359 11.573V12.7061C14.9359 12.8249 15.0786 12.885 15.1631 12.8011L19.887 8.03808C19.9563 7.96822 20.0685 7.96822 20.1378 8.03808L26.2432 14.1941C26.3125 14.264 26.3125 14.3772 26.2432 14.447L23.3623 17.3518C23.2931 17.4217 23.1808 17.4217 23.1115 17.3518L20.1378 14.3534C20.0685 14.2835 19.9563 14.2835 19.887 14.3534L7.45862 26.8849C7.38795 26.9561 7.2757 26.9561 7.20642 26.8863ZM34.2276 19.2757L33.453 18.4947C33.3838 18.4248 33.2715 18.4248 33.2022 18.4947L20.135 31.6703C20.0658 31.7401 19.9535 31.7401 19.8842 31.6703L13.7802 25.5142C13.7109 25.4444 13.7109 25.3312 13.7802 25.2613L16.6611 22.3566C16.7304 22.2867 16.8426 22.2867 16.9119 22.3566L19.8856 25.3549C19.9549 25.4248 20.0671 25.4248 20.1364 25.3549L30.0719 15.3384C30.1412 15.2686 30.1412 15.1554 30.0719 15.0855L29.2973 14.3045C29.2211 14.2277 29.2627 14.0977 29.368 14.0782L35.3903 12.98C35.4817 12.9632 35.5607 13.0442 35.5441 13.1351L34.4549 19.2073C34.4327 19.3121 34.3039 19.3526 34.2276 19.2757Z"
              fill="#00B4FF"
            />
          </svg>
        </div>
        <ul className={style.linksContainer}>
          {props.links
            ? props.links.map((link, ind) => {
              return (
                <li key={ind} className={style.linkElement}>
                  {link.titre["fr"] === "Le Mag" ? (
                    <a
                      href={`https://mag.agenz.ma/`}
                      target="__blank"
                      rel="nofollow noopener noreferrer noindex"
                    >
                      {link.titre[props.lang]}
                    </a>
                  ) : (
                    <a
                      data-tracking="click"
                      data-value="footer"
                      href={formatUrl(`/${lang}${link.path}`, lang)}
                      rel={
                        link.path.includes("list") ||
                          link.path.includes("map") ||
                          link.path.includes("?") ||
                          link.path.includes("conditions") ||
                          link.path.includes("contact")
                          ? "nofollow noopener noreferrer noindex"
                          : "follow"
                      }
                    >
                      {link.titre[props.lang]}
                    </a>
                  )}
                </li>
              );
            })
            : menus.map((link, ind) => {
              return (
                <li key={ind} className={style.linkElement}>
                  <a
                    data-tracking="click"
                    data-value="footer"
                    rel={
                      link.path.includes("list") ||
                        link.path.includes("map") ||
                        link.path.includes("?") ||
                        link.path.includes("conditions") ||
                        link.path.includes("contact")
                        ? "nofollow noopener noreferrer noindex"
                        : "follow"
                    }
                    href={formatUrl(`${link.path}`, lang)}
                  >
                    {link.title}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      {props.propos || props.donnee || props.technologie ? (
        <div className={style.agenzInfos}>
          <div className={style.agenzInfosElement}>
            <p className={style.title}>{props.propos}</p>
            <p className={style.text}>{props.proposText}</p>
          </div>
          <div className={style.agenzInfosElement}>
            <p className={style.title}>{props.donnee}</p>
            <p className={style.text}>{props.donneeText}</p>
          </div>
          <div className={style.agenzInfosElement}>
            <p className={style.title}>{props.technologie}</p>
            <p className={style.text}>{props.technologieText}</p>
          </div>
        </div>
      ) : (
        <div className={style.agenzInfos}>
          <div className={style.agenzInfosElement}>
            <p className={style.title}>{t("À propos")}</p>
            <p className={style.text}>{t("AgenzMission text")}</p>
          </div>
          <div className={style.agenzInfosElement}>
            <p className={style.title}>{t("Nos données")}</p>
            <p className={style.text}>{t("Nos données Text")}</p>
          </div>
          <div className={style.agenzInfosElement}>
            <p className={style.title}>{t("Notre technologie")}</p>
            <p className={style.text}>{t("Notre technologie Text")}</p>
          </div>
        </div>
      )}
      <div className={style.subFooter}>
        <div className={style.subFooterLogo}>
          <div className={style.logo}>
            {props.logo ? (
              <Image
                unoptimized
                src={props.logo}
                alt="logo-agenz"
                width={111}
                height={32}
              />
            ) : (
              <Logo />
            )}
          </div>
          <div className={style.social}>
            <p className={style.suivi}>{t("Suivez nous")}: </p>
            <div className={style.socialIcons}>
              <a
                aria-label="Facebook"
                href="https://www.facebook.com/Agenztechnologies"
                target="_blank"
                rel="noreferrer nofollow noopener"
              >
                {props.facebook ? (
                  <Image
                    unoptimized
                    src={props.facebook}
                    alt="facebook agenz"
                    className={style.imgIcons}
                    width={32}
                    height={32}
                  />
                ) : (
                  <Facebook />
                )}
              </a>

              <a
                aria-label="Instagram"
                href="https://instagram.com/agenz.ma?utm_medium=copy_link"
                target="_blank"
                rel="noreferrer nofollow noopener"
              >
                {props.instagram_logo ? (
                  <Image
                    unoptimized
                    src={props.instagram_logo}
                    alt="instagram agenz"
                    className={style.imgIcons}
                    width={32}
                    height={32}
                  />
                ) : (
                  <Instagram />
                )}
              </a>
              <a
                aria-label="Linkedin"
                href="https://www.linkedin.com/company/agenztechnologies/"
                target="_blank"
                rel="noreferrer nofollow noopener"
              >
                {props.linked_in ? (
                  <Image
                    unoptimized
                    src={props.linked_in}
                    alt="linkedin agenz"
                    className={style.imgIcons}
                    width={32}
                    height={32}
                  />
                ) : (
                  <LinkedIn />
                )}
              </a>
            </div>
          </div>
        </div>
        <div className={style.copyRight}>
          <p>
            © {curretY}
            <a href="https://agenz.ma/" rel="agenz site" target="_blank">
              Agenz
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
